import { List } from 'components/ui';
import ListHeader from 'components/inspection/index/list_header';
import ListItem from 'components/inspection/index/list_item';
import Loader from 'components/loader';

const Index = ({ loading, inspections, sortBy, onSortChange }) => {
  if (loading) return <Loader />;

  return (
    <List>
      <ListHeader
        visible={inspections.length > 0}
        sortBy={sortBy}
        onSortChange={onSortChange}
      />
      {
        inspections.map((inspection) => (
          <ListItem key={inspection.id} inspection={inspection} />
        ))
      }
    </List>
  );
};

export default Index;
